import { useCallback } from 'react';
import { prop, pick } from 'ramda';
import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { get } from 'js/utils/fetch.util';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';
import { useAppSelector, useUserSelector, useDeviceSelector } from 'js/store/hooks';

import * as Types from './types';
import * as helpers from './helpers';
import { updateGamesConfiguration } from '../../store/actions';

let promise: Promise<Types.IGamesConfiguration> | undefined;
let cachedLang = '';

export const useGetGamesConfiguration = () => {
    const dispatch = useDispatch();
    const lang = useUserSelector(prop('lang'));
    const getCMSResourceURL = useGetCMSResourceURL();
    const { formFactor, os, browserName } = useDeviceSelector(pick(['formFactor', 'os', 'browserName']));
    const requestStamp = useAppSelector(prop('requestStamp'));

    return useCallback(async (): Promise<Types.IGamesConfiguration> => {
        if (promise && lang === cachedLang) {
            return promise;
        }

        cachedLang = lang || '';
        promise = new Promise((resolve, reject) => {
            const gamesURL = getCMSResourceURL(`/initialResources/gamesConfiguration/${lang}`, { t: requestStamp });

            get(gamesURL)
                .then((response) => {
                    const parsedResponse = helpers.parseGamesConfigurationResponse({
                        os,
                        response,
                        formFactor,
                        browserName
                    });

                    dispatch(updateGamesConfiguration(parsedResponse));
                    dispatcher.dispatch('games:data', parsedResponse);

                    resolve(parsedResponse);
                })
                .catch((e) => {
                    reject(`[Games] unable to get games data "${gamesURL} ${e}"`);
                    promise = undefined;
                    cachedLang = '';
                });
        });

        return promise;
    }, [getCMSResourceURL, lang, requestStamp, dispatch, os, formFactor, browserName]);
};
